export default __webpack_public_path__ + "static/media/deliveries_9.59ae7adf.png";